// src/pages/CourseTime/components/slides/layouts/HtmlContent/WhyOutcomeCards.comp.jsx
import React from 'react';
import { parseInlineMarkdown } from '../../../../utils';

// The `why` body of TemplateGraphicAndText: a positive/negative outcome pair
// (if_you_do_this_well/if_you_skip_this, or the positive_label+outcome
// variant), each optionally illustrated with its own image, falling back to
// the plain body text when neither side has content.
const WhyOutcomeCards = ({ slide, origin }) => {
  const doWell = origin.positive_outcome || origin.if_you_do_this_well || '';
  const doWellLabel = origin.positive_label || (origin.if_you_do_this_well ? 'If you do this well' : '');
  const skipThis = origin.negative_outcome || origin.if_you_skip_this || '';
  const skipThisLabel = origin.negative_label || (origin.if_you_skip_this ? 'If you skip this' : '');
  const takeaway = origin.takeaway || '';
  const bodyText = origin.body_text || origin.message || '';

  const posImg = origin.positive_image_url || slide.positive_image_url || null;
  const negImg = origin.negative_image_url || slide.negative_image_url || null;

  if (!doWell && !skipThis) {
    return <>{parseInlineMarkdown(bodyText || slide.SlideContent)}</>;
  }

  return (
    <div className="outcome-container">
      <div className="outcome-grid">
        {doWell && (
          <div className="outcome-card positive">
            {posImg && (
              <div className="outcome-card-image-wrap">
                <img src={posImg} alt="Positive outcome" className="outcome-card-image" />
              </div>
            )}
            {doWellLabel && (
              <div className="outcome-header positive">
                <span className="outcome-title positive">{doWellLabel}</span>
              </div>
            )}
            <div className="outcome-body positive">
              {parseInlineMarkdown(doWell)}
            </div>
          </div>
        )}
        {skipThis && (
          <div className="outcome-card negative">
            {negImg && (
              <div className="outcome-card-image-wrap">
                <img src={negImg} alt="Negative outcome" className="outcome-card-image" />
              </div>
            )}
            {skipThisLabel && (
              <div className="outcome-header negative">
                <span className="outcome-title negative">{skipThisLabel}</span>
              </div>
            )}
            <div className="outcome-body negative">
              {parseInlineMarkdown(skipThis)}
            </div>
          </div>
        )}
      </div>
      {takeaway && (
        <div className="content-so-what">
          {parseInlineMarkdown(takeaway)}
        </div>
      )}
    </div>
  );
};

export default WhyOutcomeCards;
